import { utilities } from "@/constants/Inputs";

export const routeNames = {
    DEFAULT: 'Default',
    LOGIN: 'Login',
    CALLBACK: 'Callback',
    AUTHENTICATION: 'Authentication',
    APP: 'App',
    MODE: 'Mode',
    RESIZE: 'Resize',
    EDITOR: 'Editor',
    GENERATE: 'Generate',
    TRANSLATE: 'Translate',
    BUTTON_GIF: 'ButtonGif',
    DYNAMIC_CREATIVE: 'DynamicCreative',
    NOT_FOUND: 'NotFound',
    PROFILE_SELECTION: 'ProfileSelection',
    AI_IMAGE_EDIT: 'AiImageEdit',
    AI_IMAGE_EDIT_INPUTS: 'AiImageEditInputs',
    BUTTON_GIF_INPUTS: 'ButtonGifInputs',
    GRAB_ENGINE: 'GrabEngine',
}

export const routesMap = {
  [utilities.resize]: routeNames.RESIZE,
  // [utilities.translate]: routeNames.TRANSLATE,
  [utilities.generate]: routeNames.GENERATE,
  [utilities.dynamicCreative]: routeNames.DYNAMIC_CREATIVE,
  [utilities.AIEditor]: routeNames.AI_IMAGE_EDIT,
};